import { useState, useCallback } from 'react';
import type { ContextMenuSelectionData } from '../../calendar/lexical/plugins/ContextMenuSelectionPlugin';

interface ContextMenuState {
  isOpen: boolean;
  x: number;
  y: number;
  selectedText: string;
}

const INITIAL_STATE: ContextMenuState = {
  isOpen: false,
  x: 0,
  y: 0,
  selectedText: '',
};

export function useNoteContextMenu() {
  const [contextMenuState, setContextMenuState] = useState<ContextMenuState>(INITIAL_STATE);

  const openContextMenu = useCallback((data: ContextMenuSelectionData) => {
    setContextMenuState({
      isOpen: true,
      x: data.x,
      y: data.y,
      selectedText: data.selectedText,
    });
  }, []);

  const closeContextMenu = useCallback(() => {
    setContextMenuState(INITIAL_STATE);
  }, []);

  return { contextMenuState, openContextMenu, closeContextMenu };
}
